/* eslint-disable @typescript-eslint/no-explicit-any */
/*eslint-disable no-console */

import { indexOf } from 'es-toolkit/compat';
import { noop } from 'es-toolkit';

// Must be kept in order of priority
// tslint:disable:strict-type-predicates
// tslint:disable:no-console
const LOG_LEVELS: LogLevel[] = [
  'NETWORKING_FINE',
  'NETWORKING',
  'DEBUG',
  'LOG',
  'INFO',
  'WARN',
  'ERROR',
  'NONE',
];

let globalData: { LOG_LEVEL?: LogLevel } = {};
if (typeof window === 'undefined') {
  console.debug = noop;
  globalData = global as any;
} else {
  // Handle lack of console.trace in IE10.
  console.trace = console.trace || console.error;
  console.debug = console.debug || console.info;
  globalData = window;
}

let currentLogLevelIndex: number;

const loggerImpl = {
  init(logLevel: LogLevel) {
    if (currentLogLevelIndex) {
      console.warn('logger has already been initialized. Ignoring');
      return;
    }
    currentLogLevelIndex = indexOf(LOG_LEVELS, logLevel);
  },

  networkingFine(msg: string, ...args: unknown[]) {
    this._loggerFunction('NETWORKING_FINE', console.debug, msg, ...args);
  },
  networking(msg: string, ...args: unknown[]) {
    this._loggerFunction('NETWORKING', console.debug, msg, ...args);
  },
  debug(msg: string, ...args: unknown[]) {
    this._loggerFunction('DEBUG', console.debug, msg, ...args);
  },
  error(msg: string, ...args: unknown[]) {
    this._loggerFunction('ERROR', console.error, msg, ...args);
  },
  info(msg: string, ...args: unknown[]) {
    this._loggerFunction('INFO', console.info, msg, ...args);
  },
  log(msg: string, ...args: unknown[]) {
    this._loggerFunction('LOG', console.log, msg, ...args);
  },
  warn(msg: string, ...args: unknown[]) {
    this._loggerFunction('WARN', console.warn, msg, ...args);
  },

  _loggerFunction(
    level: LogLevel,
    logFunc: (...args: unknown[]) => void,
    msg: string,
    ...args: unknown[]
  ) {
    const timestamp = new Date().toISOString();
    if (typeof currentLogLevelIndex !== 'number') {
      console.error('Logger has not been initialized yet!');
      console.error(`${timestamp} [${level}] ${msg}`, ...args);
      return;
    }
    const logLevelIndex = globalData.LOG_LEVEL
      ? indexOf(LOG_LEVELS, globalData.LOG_LEVEL)
      : currentLogLevelIndex;
    if (indexOf(LOG_LEVELS, level) < logLevelIndex) {
      return;
    }
    try {
      logFunc(`${timestamp} [${level}] ${msg}`, ...args);
    } catch (e) {
      console.trace(e);
    }
  },
};

if (process.env.NODE_ENV === 'development') {
  (console as any).init = console.debug;
  (console as any).networkingFine = console.debug;
  (console as any).networking = console.debug;
}

export const logger =
  process.env.NODE_ENV === 'development' ? (console as any as typeof loggerImpl) : loggerImpl;
